<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ytcDOD/tc-custom/9781638295143.jpg?1705766126803" alt="This image is the cover for the book The Unusual Cure and Untold Story of Dr. John Langone, Dr. of Psychiatry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Unusual Cure and Untold Story of Dr. John Langone, Dr. of Psychiatry
      </h1>
      <p class="bookDescription body article font2">
        <p>This work of fiction, entitled <em>The Unusual Cure and Untold Story of Dr. John Langone, Dr. of Psychiatry</em>, tells the story of a depressed psychiatrist who contemplates suicide. He falls in love with the heroine of the story, and his life changes from that moment on. It is a true tragedy with an extensive cast of characters involved.  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vernon Michael dechastaigne Craig
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;background:white;'><span style='font-family:"Times New Roman",serif;color:black;'>Vernon Michael Dechastaigne Craig was born in New York City. His father was a Marine Corps Captain wounded in Guadalcanal, Solomon Islands during World War II. Vernon Craig attended night school at Harvard Extension and also attended the College of William and Mary.</span></p><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;background:white;'><br></p><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:15px;font-family:"Calibri",sans-serif;text-align:justify;background:white;'><span style='font-family:"Times New Roman",serif;color:black;'>He is a lead actor in the American movie <em>The Man Who Knew Bush</em>, also, Unicow Productions of <em>Satan and the Saint</em>, which was distributed by Indie Elix Seattle Washington.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?873b84c6